module.exports = __webpack_public_path__ + "static/media/update.7d3537be.svg";